// Distribuição
import estatistica from './estatistica';

export default {
  estatistica,
};
